// Common
import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

// Vue Router
import VueRouter from 'vue-router';
import router from './router.js';
Vue.use(VueRouter);

// Vuex
import store from './store.js';

// i18n
import i18n from './i18n';
if (localStorage.getItem('locale'))
  i18n.locale = localStorage.getItem('locale');

// Print
import Print from 'vue-print-nb'
Vue.use(Print);

// 服务器回复通用解析工具
import resparse from './api/resparse';
Vue.prototype.$resparse = resparse;

// Self-made Snackbar
import snackbar from './plugins/snackbar';
Vue.prototype.$snackbar = snackbar;

import consts from "./consts.js";
Vue.prototype.$consts = consts;

// 权限工具
import permission from './plugins/permission';
Vue.prototype.$permission = permission;

// 时间格式工具
import datetimeUtils from './plugins/datetimeUtils';
Vue.prototype.$datetimeUtils = datetimeUtils;

// 数字格式工具
import numberFormatter from './plugins/numberFormatter';
Vue.prototype.$numberFormatter = numberFormatter;

Vue.prototype.$scrollIntoView = function (elemID) {
  var top = document.getElementById(elemID);
  if (top) top.scrollIntoView();
}
Vue.prototype.$scrollTop = function () {
  var ele = document.getElementById("main-content");
  if (ele) ele.scrollTo(0, 0);
}
Vue.prototype.$scrollLocation = 0;
Vue.prototype.$cacheScrollLocation = function(){
  Vue.prototype.$scrollLocation = document.getElementById("main-content").scrollTop;
};
Vue.prototype.$scrollToCachedLocation = function(delay){
  setTimeout(
    function () {
      document.getElementById("main-content").scrollTo(0, Vue.prototype.$scrollLocation);
    }.bind(this),
    typeof delay == 'undefined' ? 0 : delay // 延时避免动画冲突的话建议delay设为650
  );
};
Vue.prototype.$mainResizer = function() {
  let node = document.getElementById("fix-header");
  if (node && window.innerWidth >= 800) {
    store.commit("fixHeaderHeightInPx", node.scrollHeight);
  } else {
    store.commit("fixHeaderHeightInPx", 0);
  }
};
Vue.prototype.$setIntervalMainResizer = function() {
  if (store.state.mainContentScrolled != 0) return;
  let node = document.getElementById("fix-header");
  if (node) {
    let orgHeight = node.scrollHeight;
    let preHeight = node.scrollHeight;
    let tries = 0;
    var myVar = setInterval(
      function () {
        if (
          tries < 10 &&
          orgHeight != node.scrollHeight &&
          preHeight == node.scrollHeight
        ) {
          this.$mainResizer();
          clearInterval(myVar);
        } else {
          preHeight = node.scrollHeight;
          tries++;
        }
      }.bind(this),
      100
    );
  }
};

// validate 本地化和自定义扩展
import "./validate.js";

// commonUtils
import commonUtils from "@/plugins/commonUtils";
Vue.prototype.$commonUtils = commonUtils;

// printUtils
import printUtils from "@/plugins/printUtils";
Vue.prototype.$printUtils = printUtils;

// requestConfig
import requestConfigs from "@/api/request_configs";
Vue.prototype.$oldPlatform = requestConfigs.OldPlatform;
Vue.prototype.$LogoFolder = requestConfigs.LogoFolder;
Vue.prototype.$BaseURL = requestConfigs.BaseURL;
Vue.prototype.$showLocaleChange = requestConfigs.showLocaleChange;

Vue.prototype.$showFullscreenImages = function (imgs, currentIndex) {
  if (!imgs) { store.commit('fullscreenImages', null); return; }
  let length = imgs.length;
  if (!currentIndex) currentIndex = 0;
  var fullscreenImages = [];
  imgs.forEach((img, index) => {
    fullscreenImages.push(imgs[(index + currentIndex) % length])
  });
  store.commit('fullscreenImages', fullscreenImages);
}

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')